import { AccountDisabledNotification } from 'src/components/common/AccountDisabledNotification';
import { AccountInactiveNotification } from 'src/components/common/AccountInactiveNotification';
import { useCatalogDataContext } from 'src/contexts/CatalogDataContext';
import { CatalogMultiSelectionContextProvider } from 'src/contexts/CatalogMultiSelectionContext';
import { useContent } from 'src/contexts/ContentContext';
import { DialogProvider } from 'src/contexts/DialogContext/DialogContext';
import { MobileDrawerProvider } from 'src/contexts/MobileDrawerContext';
import { MobileListingDrawerContextWrapper } from 'src/contexts/MobileListingDrawerContext/MobileListingDrawerContext';
import {
  IneventorySortingType,
  MobileInventorySortAndFilterContextProvider,
} from 'src/contexts/MobileSortAndFilterContext';
import { MultiSelectionContextProvider } from 'src/contexts/MultiSelectionContext';
import { PosSpinner } from 'src/core/POS/PosSpinner';
import { LayoutContent } from 'src/navigations/LayoutContent';
import { ContentId } from 'src/utils/constants/contentId';

import { MainRoute } from '../../MainRoute';
import { EventFilterBar } from './components/EventFilterBar';
import { EventGroupedTiles } from './components/EventGroupedList';

export const InventoryEventsMobile = () => {
  const routeTitle = useContent(ContentId.Inventory);
  const { isLoading, eventsTransformed } = useCatalogDataContext();
  if (isLoading) {
    return <PosSpinner />;
  }

  return (
    <CatalogMultiSelectionContextProvider type="listing">
      <MultiSelectionContextProvider>
        <MobileInventorySortAndFilterContextProvider
          type={IneventorySortingType.Event}
        >
          <MobileDrawerProvider>
            <DialogProvider>
              <LayoutContent
                mainRoute={MainRoute.Inventory}
                routeTitle={routeTitle}
              >
                <MobileListingDrawerContextWrapper>
                  <AccountDisabledNotification />
                  <AccountInactiveNotification />
                  <EventFilterBar />
                  <EventGroupedTiles eventsTransformed={eventsTransformed} />
                </MobileListingDrawerContextWrapper>
              </LayoutContent>
            </DialogProvider>
          </MobileDrawerProvider>
        </MobileInventorySortAndFilterContextProvider>
      </MultiSelectionContextProvider>
    </CatalogMultiSelectionContextProvider>
  );
};
